import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { getViewByValueFromStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import React, { useMemo } from 'react';
import { FilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import { FilterListBoxItem } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { ViewByDropdownOptions } from 'libs/end-to-end/src/view-by';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';

export const ViewByMenu = ({
  store,
  feature,
  databaseRevisionId,
  databaseId,
  organizationId,
  closeMenu,
  setPrimaryFilters,
  focusArea,
  analysisName,
}: {
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  closeMenu: () => void;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  focusArea: FocusArea | null;
  analysisName: string | undefined;
}) => {
  const items: FilterListBoxItem[] = useMemo(() => {
    const viewByStoreValue = getViewByValueFromStore({
      store,
      feature,
      focusArea,
      analysisName,
      databaseId,
      databaseRevisionId,
      organizationId,
    });

    return ViewByDropdownOptions.map((item) => ({
      value: item.optionValue,
      translatedContent: item.optionLabel,
      selected: item.optionValue === viewByStoreValue,
    }));
  }, [
    feature,
    organizationId,
    databaseRevisionId,
    databaseId,
    store,
    focusArea,
    analysisName,
  ]);

  return (
    <Box bg={'white'} w={'32'}>
      <FilterListBox
        multiple={false}
        items={items}
        onUpdate={({ addedSelections }) => {
          const primaryFiltersSelections: PrimaryFilterSelection[] = [
            {
              primaryFilterKey: 'viewBy',
              value: addedSelections[0],
            },
          ];

          setPrimaryFilters({ selections: primaryFiltersSelections });

          closeMenu();
        }}
      />
    </Box>
  );
};
